module.exports = __webpack_public_path__ + "img/gallery-22.f63de232.jpg";